import clsx from 'clsx';
import type { PropsWithChildren } from 'react';

import { MeterBarChartOverlayWithTooltip } from './MeterBarChartOverlayWithTooltip.js';
import { Flex } from '../../../../../layouts/flex/Flex.js';
import { useMeterBarChartLoading } from '../../../shared/context/MeterBarChartLoadingContext.js';
import { useMeterBarLayoutSize } from '../../../shared/context/MeterBarLayoutSizeContext.js';
import { elementSize } from '../../../shared/styles/element-size.sty.js';
import { container } from '../../../shared/styles.sty.js';
import { useMeterBarChartInternalConfig } from '../../context/MeterBarChartInternalConfigContext.js';

export const MeterBarChartOverlay = ({ children }: PropsWithChildren) => {
  const { size } = useMeterBarLayoutSize();
  const { tooltip } = useMeterBarChartInternalConfig();
  const loading = useMeterBarChartLoading();

  if (!tooltip || loading) {
    return (
      <Flex
        className={clsx(container, elementSize({ size }))}
        data-testid="overlay-wrapper"
      >
        {children}
      </Flex>
    );
  }

  return (
    <MeterBarChartOverlayWithTooltip>
      {children}
    </MeterBarChartOverlayWithTooltip>
  );
};
